import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Entity } from '../../models/entity';

@Component({
  standalone: false,
  selector: 'gstar-select-or-add-entity',
  templateUrl: './select-or-add-entity.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectOrAddEntityComponent {
  @Input() disabled!: boolean;
  @Input() entity?: Entity | null;
  @Input() preserveSelectionOnClientChange: boolean = false;

  @Output() updateEntity: EventEmitter<Entity | null | undefined> =
    new EventEmitter();

  showAddEntity: boolean = false;

  selectEntity(entity: Entity | null | undefined): void {
    this.updateEntity.emit(entity);
  }

  createEntity(): void {
    this.showAddEntity = true;
  }

  loadNewEntity(entity: Entity): void {
    this.updateEntity.emit(entity);
  }
}
